import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatInTimeZone } from 'date-fns-tz';
import './TimezoneSwitcher.css';

const TimezoneSwitcher = ({ isOpen, onClose, timezones, selectedTimezone, onTimezoneChange }) => {
  const { i18n } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');

  const getGmtOffsetString = (timezone) => {
    try {
      return `GMT${formatInTimeZone(new Date(), timezone, 'xxx')}`;
    } catch (e) { return ''; }
  };

  const getLocalizedTimezoneName = (timezone, lang) => {
    try {
      const formatter = new Intl.DateTimeFormat(lang, { timeZone: timezone, timeZoneName: 'long' });
      const parts = formatter.formatToParts(new Date());
      const tzNamePart = parts.find(part => part.type === 'timeZoneName');
      return tzNamePart ? tzNamePart.value : timezone.replace(/_/g, ' ');
    } catch (error) { return timezone.replace(/_/g, ' '); }
  };

  const processedTimezones = useMemo(() => {
    return timezones.map(tz => {
      const localizedName = getLocalizedTimezoneName(tz, i18n.language);
      return {
        id: tz,
        name: localizedName,
        searchableText: `${tz.toLowerCase()} ${localizedName.toLowerCase()}`
      };
    });
  }, [timezones, i18n.language]);

  const filteredAndSortedTimezones = useMemo(() => {
    // Önce arama terimine göre filtrele
    const filtered = searchTerm
      ? processedTimezones.filter(tz => tz.searchableText.includes(searchTerm.toLowerCase()))
      : processedTimezones;

    // DEĞİŞİKLİK BURADA BAŞLIYOR
    const selected = filtered.find(tz => tz.id === selectedTimezone);
    const others = filtered.filter(tz => tz.id !== selectedTimezone);

    // Seçili olan varsa listenin başına koy, yoksa sadece diğerlerini döndür
    return selected ? [selected, ...others] : others;
    // DEĞİŞİKLİK BİTİŞİ

  }, [searchTerm, processedTimezones, selectedTimezone]);

  useEffect(() => {
    if (!isOpen) {
      setSearchTerm('');
    }
  }, [isOpen]);
  
  if (!isOpen) return null;

  return (
    <div className="timezone-modal-overlay" onClick={onClose}>
      <div className="timezone-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="timezone-modal-header">
          <h4>{i18n.t('select_timezone_title', 'Zaman Dilimi Seçin')}</h4>
          <button onClick={onClose} className="close-btn">×</button>
        </div>
        
        <div className="search-bar-container">
          <i className="fas fa-search"></i>
          <input
            type="text"
            className="timezone-search-input"
            placeholder={i18n.t('search_timezone_placeholder', 'Zaman dilimi ara...')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
        </div>
        
        <ul className="timezone-list">
          {filteredAndSortedTimezones.length > 0 ? (
            filteredAndSortedTimezones.map(tz => (
              <li 
                key={tz.id} 
                onClick={() => {
                  onTimezoneChange(tz.id);
                  onClose();
                }}
                className={selectedTimezone === tz.id ? 'active' : ''}
              >
                <span className="timezone-name">{tz.name}</span>
                <span className="timezone-gmt">{getGmtOffsetString(tz.id)}</span>
              </li>
            ))
          ) : (
            <li className="no-results">{i18n.t('no_results_found', 'Sonuç bulunamadı')}</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default TimezoneSwitcher;